<div class="container">
    <section class="bg-white my-4 py-5">
        <nb-card>
            <nb-card-body>
                <div class="auth-block">
                    <router-outlet></router-outlet>
                </div>
            </nb-card-body>
        </nb-card>
    </section>
</div>
